/**
 * A widget for display of numeric data and description.
 */
import React, { Component } from 'react';
import { Grid, Paper, Popover, TableContainer, Table,  TableBody, TableCell, TableHead, TableRow, Tooltip, Typography} from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import HelpOutline from '@mui/icons-material/HelpOutline';
import { format } from 'date-fns';

const styleSheet = theme => ({
  root: {
    width: '100%',
  },
  dbTile: {
    [theme.breakpoints.up('xs')]: {
      padding: theme.spacing(1),
    },
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(1),
    },
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(2),
    },
    height: 68,
    width: 212
  },
  dbTile2: {
    [theme.breakpoints.up('xs')]: {
      padding: theme.spacing(1),
    },
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(1),
    },
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(2),
    },
    height: 68,
    width: 184
  },
});
  
class AvailableBalanceTextWidget extends Component {

  constructor(props) {
    super(props);
 

    this.state = {
      anchorEl: null
    };  
  }
  handlePopoverOpen = (event) => {
    if (event) {
      this.setState({anchorEl: event.currentTarget});
    }
  };

  handlePopoverClose = () => {
    this.setState({anchorEl: null});
  };
    
  render() {
    const classes = this.props.classes;

    const { narrow, value, description, tooltip } = this.props;

    let theNodes = this.props.pendingReceipts;



    const open = Boolean(this.state.anchorEl);

    let theTileClass = classes.dbTile;
    if (narrow === true) {
      theTileClass = classes.dbTile2;
    }

    if (theNodes && theNodes.length > 0) {
      let achPercAvailableOnCharge = Number(this.props.accountPercentages.achPercAvailableOnCharge);
      let achMinAvailableOnCharge = Number(this.props.accountPercentages.achMinAvailableOnCharge);
      let ccPercAvailableOnCharge = Number(this.props.accountPercentages.ccPercAvailableOnCharge);
      let ccMinAvailableOnCharge = Number(this.props.accountPercentages.ccMinAvailableOnCharge);
  

      let ccTotal = 0;
      let achTotal = 0;
      let totalAvailable = 0;

      for (let i=0; i<theNodes.length; i++) {
        let n = theNodes[i];
        if (n.extSource === "dwolla") {
          achTotal = achTotal + Number(n.changeAmount);
        } else if (n.extSource === "stripe") {
          ccTotal = ccTotal + Number(n.changeAmount);
        }
      }

      //compute total available.
      let workingACH = achTotal * (achPercAvailableOnCharge / 100);
      if (workingACH < achMinAvailableOnCharge) {
        if (achMinAvailableOnCharge < achTotal) {
          workingACH = achMinAvailableOnCharge;
        } else {
          workingACH = achTotal;
        }
      }
      let workingCC = ccTotal * (ccPercAvailableOnCharge / 100);
      if (workingCC < ccMinAvailableOnCharge) {
        if (ccMinAvailableOnCharge < ccTotal) {
          workingCC = ccMinAvailableOnCharge;
        } else {
          workingCC = ccTotal;
        }
      }
      totalAvailable = workingACH + workingCC;
      let availableAmountFormatted = Number(totalAvailable).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});

      return (
        <Paper className={theTileClass}>
          <div
            aria-owns={open ? 'mouse-over-popover' : undefined}
            aria-haspopup="true"
            onMouseEnter={this.handlePopoverOpen}
            onMouseLeave={this.handlePopoverClose}>
              <Grid container spacing={1} direction="column" justifyContent="flex-start" alignItems="center">
                <Grid item>
                  <Typography variant="h6">{value}</Typography>
                </Grid>
                <Grid item>
                  <Grid container justifyContent="flex-start" alignItems="center" spacing={0}>
                    <Grid>
                      <Typography variant="body2" style={{marginTop: 2}}>{description}</Typography>
                    </Grid>
                    <Grid item>
                      <Tooltip placement='bottom' title={tooltip}>
                        <HelpOutline fontSize="small" style={{verticalAlign: "-9%", marginLeft: '4px'}}/>
                      </Tooltip>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>

          </div>
          <Popover
            id="mouse-over-popover"
            sx={{
              pointerEvents: 'none',
            }}
            open={open}
            anchorEl={this.state.anchorEl}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}
            onClose={this.handlePopoverClose}
            disableRestoreFocus>
            <TableContainer>
                <Table>
                  <TableHead className={classes.tblHead}>
                    <TableRow className={classes.tblHeadRow}>
                      <TableCell className={classes.tblHeadCell}>Date</TableCell>
                      <TableCell className={classes.tblHeadCell}>Type</TableCell>
                      <TableCell className={classes.tblHeadCell}>Description</TableCell>
                      <TableCell className={classes.tblHeadCell}>Amount</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    { theNodes.map(n => {
                      //format date
                      let transactionTime = format(new Date(n.transactionTime+'Z'), 'yyyy-MM-dd pp');
                      let amount = Number(n.changeAmount).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});

                      let type = '';
                      if (n.extSource === "dwolla") {
                        type = 'ACH';

                      } else if (n.extSource === "stripe") {
                        type = 'Credit card';

                      }                      

                      return (
                        <TableRow key={n.transactionId} >
                          <TableCell style={{whiteSpace: 'nowrap'}} className={classes.tblCellDateCol}>{transactionTime}</TableCell>
                          <TableCell>{type}</TableCell>
                          <TableCell>{n.transDescription}</TableCell>
                          <TableCell>{amount}</TableCell>
                          
                        </TableRow>
                      );
                    })}
                    <TableRow>
                      <TableCell style={{whiteSpace: 'nowrap'}} className={classes.tblCellDateCol}></TableCell>
                      <TableCell></TableCell>
                      <TableCell>Total Available</TableCell>
                      <TableCell>{availableAmountFormatted}</TableCell>
                    </TableRow>

                  </TableBody>
                </Table>
              </TableContainer>

            </Popover>
        </Paper>
      );
    } else {
      return (
        <Paper className={theTileClass}>
          <Grid container spacing={1} direction="column" justifyContent="flex-start" alignItems="center">
            <Grid item>
              <Typography variant="h6">{value}</Typography>
            </Grid>
            <Grid item>
              <Grid container justifyContent="flex-start" alignItems="center" spacing={0}>
                <Grid>
                  <Typography variant="body2" style={{marginTop: 2}}>{description}</Typography>
                </Grid>
                <Grid item>
                  <Tooltip placement='bottom' title={tooltip}>
                    <HelpOutline fontSize="small" style={{verticalAlign: "-9%", marginLeft: '4px'}}/>
                  </Tooltip>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Paper>
      );
    }


  }
}

export default withStyles(styleSheet)(AvailableBalanceTextWidget);

